import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import getAllData from '../../../api/services/SchedulingEvent/getAllDataForm.service';
const initialState = {
    getPrimaryProvider: [],
    additionalParticipants: [],
    getLocation: <any>[],
    getAuthAndNonBillable: [],
    value: [],
    error: false,
    loading: false,
    billableCodes: [],
    mins: <any>[],
    hours: <any>[],
    participants: [],
    authCodeButton: null,
    isValidDuration: false,
    fromTime: '',
    toTime: '',
    unitOfService: <any>'',
    timezone: <any>'',
    startTime: '',
    endTime: '',
    codeAfterEdit: '',
    codeAfterEditing: [],
    appointmentCodes: '',
    setCodes: '',
    isAuthorizationCodesEdited: false,
    completeScheduleEvent: '',
    currentWeekStart: '',
    currentWeekEnd: '',
    plannerView: false,
    weekDays: [],
    provider: null,
    saveNoteId: '',
    selectAppointmentDate: '',
    clientData: {},
    userTimeZone: '',
    appointmentRecurrenceId: '',
    childPayorId: '',
    calendarView: 'week',
    calendarViewSmall: 'month',
    selectedTabVal: 'Week',
    selectedTab: 2,
    onEditAuth: false,
    exceedError: false,
    warning: false,
    mismatchError: false,
    isSessionNote: false,
    view: '',
};
interface MyData {
    codeType: any;
    clientId: any;
    serviceProviderId: any;
    startTime: any;
}
export const getPrimaryProvider = createAsyncThunk(
    'primaryProvider/getPrimaryProvider',
    async (_, thunkAPI) => {
        try {
            const res = await getAllData.getTechnicianAndClinician();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getPrimaryProviderActiveInactive = createAsyncThunk(
    'primaryProvider/getPrimaryProviderActiveInactive',
    async (_, thunkAPI) => {
        try {
            const res =
                await getAllData.getTechnicianAndClinicianActiveInactive();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAllAdditionalParticipants = createAsyncThunk(
    'primaryProvider/getAllAdditionalParticipants',
    async (_, thunkAPI) => {
        try {
            const res = await getAllData.getAllAdditionalParticipants();
            return res.data.data;
        } catch (err) {
            // Return the error to be handled by the rejection action
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getLocation = createAsyncThunk(
    'getLocation',
    async (_, thunkAPI) => {
        try {
            const res = await getAllData.getPlaceAndService();
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err);
        }
    }
);
export const getAuthorizationAndNonBillable = createAsyncThunk(
    'getAuthorizationAndNonBillable',
    async (payload: MyData, { rejectWithValue }) => {
        try {
            const res =
                await getAllData.getAuthorizationAndNonBillable(payload);
            return res.data.data;
        } catch (err) {
            rejectWithValue('Error in Response');
        }
    }
);
const SchedulingSlice = createSlice({
    name: 'scheduling',
    initialState,
    reducers: {
        savingAppointmentDate: (state: any, action: any): any => {
            state.selectAppointmentDate = action.payload;
        },
        setCalendarView: (state: any, action: any): any => {
            state.calendarView = action.payload;
        },
        setCalendarViewSmall: (state: any, action: any): any => {
            state.calendarViewSmall = action.payload;
        },
        setSelectedTabValue: (state: any, action: any): any => {
            state.selectedTabVal = action.payload;
        },
        setSelectedTab: (state: any, action: any): any => {
            state.selectedTab = action.payload;
        },
        setOnEditAuth: (state: any, action: any): any => {
            state.onEditAuth = action.payload;
        },
        savingBillableCodes: (state: any, action: any) => {
            const index = state.billableCodes.findIndex(
                (item: any) => item.key === action?.payload?.key
            );
            if (index !== -1) {
                state.billableCodes[index] = action?.payload;
            } else {
                state.billableCodes = [
                    ...(state?.billableCodes || []),
                    action?.payload,
                ];
            }
        },
        savingAuthCodes: (state, action) => {
            state.authCodeButton = { ...action?.payload };
        },
        resetAuthCode: (state) => {
            state.authCodeButton = null;
        },
        setPlannerView: (state, action) => {
            state.plannerView = action.payload;
        },
        setView: (state, action) => {
            state.view = action.payload;
        },
        savingHours: (state: any, action: any) => {
            // Ensure state.hours is initialized as an array
            if (!Array.isArray(state.hours)) {
                state.hours = [];
            }
            const index = state.hours.findIndex(
                (item: any) => item.key === action.payload.key
            );
            if (index !== -1) {
                state.hours[index] = action.payload;
            } else {
                state.hours = [...state.hours, action.payload];
            }
        },
        savingMins: (state: any, action: any) => {
            // Ensure state.mins is initialized as an array
            if (!Array.isArray(state.mins)) {
                state.mins = [];
            }
            const index = state.mins.findIndex(
                (item: any) => item.key === action.payload.key
            );
            if (index !== -1) {
                state.mins[index] = action.payload;
            } else {
                state.mins = [...state.mins, action.payload];
            }
        },
        savingParticipants: (state: any, action: any) => {
            // Ensure state.participants is initialized as an array
            if (!Array.isArray(state.participants)) {
                state.participants = [];
            }
            // Safely update the state with the new payload
            state.participants = [
                ...state.participants, // No need for optional chaining here
                action.payload,
            ];
        },
        removeParticipants: (state: any, action: any) => {
            if (!Array.isArray(state.participants)) {
                state.participants = [];
            }

            // Filter out the participant that matches the condition (e.g., by id)
            state.participants = state.participants.filter(
                (participant: any) => participant !== action.payload
            );
        },
        clearHours: (state) => {
            state.mins = [];
            state.hours = [];
            state.billableCodes = [];
            state.participants = [];
            state.setCodes = '';
            state.appointmentCodes = '';
            state.saveNoteId = '';
            state.appointmentCodes = '';
        },
        setAppointmentRecurrenceId: (state, action) => {
            state.appointmentRecurrenceId = action.payload;
        },
        setIsValidDuration: (state, action) => {
            state.isValidDuration = action.payload;
        },
        setFromTime: (state, action) => {
            state.fromTime = action.payload;
        },
        setToTime: (state, action) => {
            state.toTime = action.payload;
        },
        setCurrentWeekStart: (state, action) => {
            state.currentWeekStart = action.payload;
        },
        setCurrentWeekEnd: (state, action) => {
            state.currentWeekEnd = action.payload;
        },
        setAppointmentCodes: (state: any, action: any) => {
            state.appointmentCodes = action.payload;
        },
        deleteHours: (state: any, action: any) => {
            state.mins = state.mins.filter(
                (item: any) => item.key !== action.payload
            );
            state.hours = state.hours.filter(
                (item: any) => item.key !== action.payload
            );
        },
        deleteAuthCodes: (state: any, action: any) => {
            state.billableCodes = state.billableCodes.filter(
                (item: any) => item.id !== action.payload
            );
        },
        setUnitOfService: (state: any, action: any) => {
            state.unitOfService = action.payload;
        },
        setStartTime: (state: any, action: any) => {
            state.startTime = action.payload;
        },
        setEndTime: (state: any, action: any) => {
            state.endTime = action.payload;
        },
        setTimezone: (state: any, action: any) => {
            state.timezone = action.payload;
        },
        codeAfterEdit: (state: any, action: any) => {
            state.codeAfterEdit = action.payload;
        },

        codeAfterEditing: (state: any, action: any) => {
            state.codeAfterEditing = action.payload;
        },
        setCodes: (state: any, action: any) => {
            state.setCodes = action.payload;
        },
        isAuthorizationCodesEdited: (state: any, action: any) => {
            state.isAuthorizationCodesEdited = action.payload;
        },
        setCompleteScheduleEvent: (state: any, action: any) => {
            state.completeScheduleEvent = action.payload;
        },
        setCurrentWeekDays: (state: any, action: any) => {
            state.weekDays = action.payload;
        },
        setClickedProvider: (state: any, action: any) => {
            state.provider = action.payload;
        },
        saveNoteId: (state: any, action: any) => {
            state.saveNoteId = action.payload;
        },
        saveUserTimeZone: (state: any, action: any) => {
            state.userTimeZone = action.payload;
        },
        setChildPayorIdAppointment: (state: any, action: any) => {
            state.childPayorId = action.payload;
        },
        setExceedError: (state: any, action: PayloadAction<boolean>): any => {
            state.exceedError = action.payload;
        },
        setWarning: (state: any, action: PayloadAction<boolean>): any => {
            state.warning = action.payload;
        },
        setMismatchError: (state: any, action: PayloadAction<boolean>): any => {
            state.mismatchError = action.payload;
        },
        clearFromTimeAndToTime: (state: any) => {
            state.fromTime = '';
            state.toTime = '';
        },
        setIsSessionNote: (state: any, action: any): any => {
            state.isSessionNote = action.payload;
        },
        clearBillingAndNonBillingCode: (state: any) => {
            state.getAuthAndNonBillable = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPrimaryProvider?.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPrimaryProvider?.fulfilled, (state: any, action) => {
                state.getPrimaryProvider = action?.payload;
                state.loading = false;
            })
            .addCase(
                getPrimaryProviderActiveInactive?.fulfilled,
                (state: any, action) => {
                    state.getPrimaryProvider = action?.payload;
                    state.loading = false;
                }
            )
            .addCase(
                getAllAdditionalParticipants?.fulfilled,
                (state: any, action) => {
                    state.additionalParticipants = action?.payload;
                    state.loading = false;
                }
            )
            .addCase(getPrimaryProvider?.rejected, (state) => {
                state.error = true;
                state.loading = false;
            })
            .addCase(getLocation.pending, (state) => {
                state.loading = true;
            })
            .addCase(getLocation.fulfilled, (state: any, action) => {
                state.getLocation = action.payload;
                state.loading = false;
            })
            .addCase(getLocation.rejected, (state) => {
                state.error = true;
                state.loading = false;
            })
            .addCase(getAuthorizationAndNonBillable.pending, (state) => {
                state.loading = true;
            })
            .addCase(
                getAuthorizationAndNonBillable.fulfilled,
                (state: any, action) => {
                    state.getAuthAndNonBillable = action.payload;
                    state.loading = false;
                }
            );
    },
});
export const {
    savingBillableCodes,
    savingHours,
    savingMins,
    savingParticipants,
    savingAuthCodes,
    resetAuthCode,
    clearHours,
    deleteHours,
    setIsValidDuration,
    deleteAuthCodes,
    setFromTime,
    setToTime,
    setUnitOfService,
    setTimezone,
    setStartTime,
    setEndTime,
    codeAfterEdit,
    setCodes,
    setAppointmentCodes,
    isAuthorizationCodesEdited,
    setCompleteScheduleEvent,
    setCurrentWeekStart,
    setCurrentWeekEnd,
    setPlannerView,
    setCurrentWeekDays,
    setClickedProvider,
    saveNoteId,
    codeAfterEditing,
    savingAppointmentDate,
    saveUserTimeZone,
    setAppointmentRecurrenceId,
    setChildPayorIdAppointment,
    setCalendarView,
    setSelectedTabValue,
    setSelectedTab,
    setCalendarViewSmall,
    clearFromTimeAndToTime,
    removeParticipants,
    setOnEditAuth,
    setExceedError,
    setWarning,
    setIsSessionNote,
    setMismatchError,
    setView,
    clearBillingAndNonBillingCode,
} = SchedulingSlice.actions;
export default SchedulingSlice.reducer;
